import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M43.7 14c-.7 0-1.2.6-1.2 1.2v.9h-9.7v2.5h9.7v17.2h-40V18.7h9.9v-2.5H2.5v-.9c0-.7-.5-1.3-1.2-1.3S0 14.6 0 15.3v24c0 .7.6 1.2 1.2 1.2s1.2-.6 1.2-1.2v-.9h40v.9c0 .7.6 1.2 1.2 1.2S45 40 45 39.3v-24c0-.7-.6-1.3-1.3-1.3z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M35 4.5H10c-.7 0-1.3.5-1.3 1.2S9.3 7 10 7h1.2v12.5h.8l6.3 6.2c1.2 1.1 2.7 1.7 4.2 1.7s3.1-.6 4.2-1.7l7.1-6.9V7H35c.7 0 1.2-.6 1.2-1.2s-.5-1.3-1.2-1.3zm-3.7 13.2L25 23.9c-1.4 1.3-3.6 1.3-4.9 0l-6.3-6.2V7h17.5v10.7z"
	})]
});
export default SvgIcon;
